var _defs, _polygon, _polygon2, _line, _line2, _line3, _line4, _line5, _polygon3, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccidental(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 336 324",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;}.cls-3{clip-path:url(#clippath);}.cls-4{fill:#f7f7f8;}.cls-5{fill:#f7f8f9;}.cls-6{fill:#fff;}.cls-7{fill:#aecb39;}.cls-8{fill:#e1dfdd;}.cls-9{fill:#07599b;}.cls-10{fill:#258dcd;}.cls-2{stroke:#b1afb0;stroke-miterlimit:10;stroke-width:5px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 185.26,
    y: 52,
    width: 82.82,
    height: 82.82
  })))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "97.9 68.4 97.9 248.56 239.45 248.56 239.45 55.54 110.77 55.54 97.9 68.4"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "85.03 81.27 85.03 235.69 226.58 235.69 226.58 42.67 123.64 42.67 85.03 81.27"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 107.55,
    y1: 126.31,
    x2: 204.06,
    y2: 126.31
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 107.55,
    y1: 145.61,
    x2: 204.06,
    y2: 145.61
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 107.55,
    y1: 164.92,
    x2: 204.06,
    y2: 164.92
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 107.55,
    y1: 184.22,
    x2: 204.06,
    y2: 184.22
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 107.55,
    y1: 203.52,
    x2: 152.59,
    y2: 203.52
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "123.64 42.67 123.64 81.27 85.03 81.27 123.64 42.67"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M226.67,58.21v70.39c28.99-12.38,28.99-38.65,28.99-38.65v-19.32l-28.99-12.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M226.67,58.21v70.39c-28.99-12.38-28.99-38.65-28.99-38.65v-19.32l28.99-12.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M223.84,103.02v-6.23h-6.23v-5.66h6.23v-6.23h2.83v-8.06c-9.34,0-16.91,7.57-16.91,16.91s7.57,16.91,16.91,16.91v-7.64h-2.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M226.67,76.85v8.06h2.83v6.23h6.23v5.66h-6.23v6.23h-2.83v7.64c7.59,0,14.01-5,16.15-11.88,.5-1.59,.76-3.28,.76-5.03,0-9.34-7.57-16.91-16.91-16.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "223.84 91.14 217.61 91.14 217.61 96.8 223.84 96.8 223.84 103.02 226.67 103.02 226.67 84.91 223.84 84.91 223.84 91.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "229.5 103.02 229.5 96.8 235.73 96.8 235.73 91.14 229.5 91.14 229.5 84.91 226.67 84.91 226.67 103.02 229.5 103.02"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccidental);
export default __webpack_public_path__ + "static/media/Accidental.99cef862de4c05cb40ca95bcd93a8c12.svg";
export { ForwardRef as ReactComponent };